<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('discounts.title') }}</h2>
      <p class="text-center">
        {{ $t('discounts.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <edit-discount-dialog :show="showEdit" :form-details="editDiscount" @close="showEdit=false"/>
          <h4 slot="header" class="card-title">{{ $t('discounts.table.tableTitle') }}</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="row">
                <div class="col-6">
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      :placeholder="$t('generic.searchInTablePlaceholder')"
                      v-model="searchQuery"
                      aria-controls="datatables">
                    </el-input>
                  </base-input>
                </div>
                <div class="col-6" v-if="$auth.can({discount: 'create'}, 'permissions')">
                  <create-discount-btn/>
                </div>
              </div>
            </div>

            <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :prop="column.prop"
                :min-width="column.minWidth"
                :label="$t(column.label)"
                :formatter="column.formatter"
                :align="column.align"
              >
              </el-table-column>
              <el-table-column
                v-if="$auth.can({discount: 'update'}, 'permissions') || $auth.can({discount: 'delete'}, 'permissions')"
                :min-width="80" align="right">
                <div slot-scope="props">
                  <base-button
                    v-if="props.row.active == false && $auth.can({discount: 'update'}, 'permissions')"
                    @click.native="handleActivate(props.row)"
                    class="mr-2"
                    type="warning"
                    size="sm"
                    icon
                    round>
                    <i class="tim-icons icon-spaceship"></i>
                  </base-button>
                  <base-button
                    v-if="$auth.can({discount: 'update'}, 'permissions')"
                    @click.native="handleEdit(props.$index, props.row)"
                    class="mr-2"
                    type="info"
                    size="sm"
                    icon
                    round
                    simple>
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                  <base-button
                    v-if="$auth.can({discount: 'delete'}, 'permissions')"
                    @click.native="handleDelete(props.$index, props.row)"
                    class=""
                    type="danger"
                    size="sm"
                    icon
                    round
                    simple>
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div
  >
</template>
<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import swal from 'sweetalert2';
import {mapActions, mapState} from "vuex";
import CreateDiscountBtn from "./CreateDiscountBtn";
import EditDiscountDialog from "./EditDiscountDialog";

export default {
  name: 'operators',
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    CreateDiscountBtn,
    EditDiscountDialog
  },
  computed: {
    ...mapState({
      error: state => state.discount.error,
      loading: state => state.discount.loading,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['id', 'name', 'type'],
      tableColumns: [
        {
          prop: 'id',
          label: 'generic.id',
          minWidth: 75
        },
        {
          prop: 'description',
          label: 'discounts.details.description',
          minWidth: 200
        },
        {
          prop: 'type',
          label: 'discounts.details.type',
          minWidth: 100,
        },
        {
          prop: 'sort_priority',
          label: 'discounts.details.sort_priority',
          minWidth: 50,
          align: "center"
        },
        {
          prop: 'active',
          label: 'discounts.details.active',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.yesNo(cellValue)
          },
          minWidth: 50,
          width: 50,
          align: "center"
        },
        {
          prop: 'updated_at',
          label: 'generic.updated',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          minWidth: 100
        },
        {
          prop: 'created_at',
          label: 'generic.created',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          minWidth: 100
        }
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      showEdit: false,
      editDiscount: {},
    };
  },
  methods: {
    ...mapActions(['LoadDiscounts', 'DeleteDiscount', 'ActivateDiscount']),
    handleEdit(index, row) {
      this.editDiscount = {
        id: row.id,
        description: row.description,
        sort_priority: row.sort_priority,
        type: row.type,
        active: row.active
      };
      this.showEdit = true;
    },
    handleActivate(row) {
      swal({
        title: this.$t('discounts.activate.text'),
        text: `'${row.id}'`,
        confirmButtonText: this.$t('discounts.activate.actionBtnLabel'),
        cancelButtonText: this.$t('discounts.activate.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.ActivateDiscount(row.id).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('discounts.activate.activatedNotification', row),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.LoadDiscounts();
            }
          })
        }
      });
    },
    handleDelete(index, row) {
      swal({
        title: this.$t('discounts.delete.text'),
        text: `'${row.id}'`,
        confirmButtonText: this.$t('discounts.delete.actionBtnLabel'),
        cancelButtonText: this.$t('discounts.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.DeleteDiscount(row).then(() => {
            if (this.error == null) {
              // this.deleteRow(row);
              this.$notify({
                type: 'success',
                message: this.$t('discounts.delete.deletedNotification', row),
                icon: 'tim-icons icon-alert-circle-exc'
              })
            }

          })
        }
      });
    },
  },
  mounted() {
    // Loading accounts data
    this.LoadDiscounts();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "$store.state.discount.data"(discounts) {
      this.tableData = discounts
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
</style>
